"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 48 48" },
  React.createElement("path", { d: "M28 4a16 16 0 0 0-13.233 24.991l-9.888 9.888a3 3 0 0 0 4.242 4.242l9.888-9.888A16 16 0 1 0 28 4zm0 28.1A12.1 12.1 0 1 1 40.1 20 12.114 12.114 0 0 1 28 32.1z" })
);

